module.exports = __webpack_public_path__ + "img/MG_2620.641ec100.jpg";